import React, { FC, useCallback, useEffect, useState } from "react";
import infoIcon from "../../../../assets/svg/purpleInfoIcon.svg";
import copyIcon from "../../../../assets/svg/copy_agency_link_icon.svg";

import { Input } from "antd";
import { openToast } from "../../../../Toasts";

import "./index.scss";
import { AdUploadFiles } from "../AdUploadFiles";
import {
  browseTemplatesUrls,
  canPerformAction,
  handleUploadNoticeFiles,
  StepKeysName,
  StepNames,
} from "../../../RaiseNoticeAdRequest/utils";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAgencyQuotesFormDataAction,
  getFilesByStageAction,
  startRequestLoadingAction,
} from "../../../../store/actions/raiseAdRequest";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";

const permittedRoles = ["admin", "only-approver","product-admin" ];
export const AdReleaseForm: FC = () => {
  const dispatch = useDispatch();
  const {
    quoteDetailsFormData,
    adReleaseFile,
    userRole,
    lastStepName,
    quoationApprovalFormData,
  } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );

  const isStepAccessible = canPerformAction(
    userRole,
    permittedRoles,
    StepNames[3],
    lastStepName,
    quoationApprovalFormData.trashed_at
  );

  const { selectedProductId, requestId } = useParams<{
    selectedProductId: string;
    requestId: string;
  }>();
  const [fileList, setFileList] = useState<any[]>(adReleaseFile);

  useEffect(() => {
    dispatch(getAgencyQuotesFormDataAction(requestId));
    dispatch(
      getFilesByStageAction({ stage: "Ad Release", request_id: requestId })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isStepAccessible && !!userRole) {
      openToast("info", "You only have view access to this information.");
    }
  }, [isStepAccessible, userRole]);

  useEffect(() => {
    setFileList(adReleaseFile);
  }, [adReleaseFile]);
  const handleCopy = useCallback(() => {
    const inputField = `${window.location.origin}#/?folder=${quoteDetailsFormData?.folder_url}`;
    if (inputField) {
      navigator.clipboard
        .writeText(inputField)
        .then(() => {
          openToast("success", "Text copied to clipboard.");
        })
        .catch((error) => {
          console.error("Failed to copy text: ", error);
        });
    }
  },[quoteDetailsFormData]);

  const handleCreativeTemplates = useCallback(() => {
    window.open(browseTemplatesUrls[selectedProductId], "_blank");
  }, [selectedProductId]);

    const handleCreativeUploadClick = useCallback(() => {
    window.open(`${window.location.origin}#/?folder=${quoteDetailsFormData?.folder_url}`, "_blank");
  }, [quoteDetailsFormData]);

  const handleSubmitUploadFile = useCallback(() => {
    if (!fileList.length) {
      openToast("error", "Please upload .eml file");
      return;
    }
    handleUploadNoticeFiles(
      fileList,
      dispatch,
      requestId,
      "Final Market go Live",
      "Ad Release",
      StepKeysName.FinalMarketGoLive,
      selectedProductId
    );
  }, [dispatch, fileList, requestId, selectedProductId]);
  return (
    <>
      <div className="layout-wrapper">
        {/* Scrollable Form */}
        <div className="layout-wrapper__body">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "2rem",
              border: "2px solid #F3ECFF",
              borderRadius: "1rem",
            }}
          >
            <div
              style={{
                padding: "2rem 1rem",
                background: "#F3ECFF",
                width: "100%",
                display: "flex",
                gap: "1rem",
                flexDirection: "column",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <img src={infoIcon} alt="Info Icon" style={{ color: "red" }} />
                <div
                  style={{ color: "#000", fontSize: "1.4rem", fontWeight: 600 }}
                >
                  No creatives yet?
                </div>
              </div>

              <div
                style={{
                  color: "#000205",
                  fontSize: "1.4rem",
                  fontWeight: 200,
                  paddingLeft: "3rem",
                }}
              >
                Download and edit creative templates before uploading your final
                assets.
              </div>

              <div style={{ marginTop: "0.5rem", paddingLeft: "3rem" }}>
                <button
                  className="btn btn--outline-purple"
                  style={{ background: "transparent", padding: "0.5rem 1rem" }}
                  onClick={handleCreativeTemplates}
                >
                  See Creative Templates
                </button>
              </div>
            </div>
          </div>

          <div
            style={{
              color: "#000",
              fontSize: "1.8rem",
              fontWeight: 500,
              marginTop: "2rem",
            }}
          >
            Upload Your Creative Here
            <span style={{ color: "red" }}>*</span>
          </div>

           <div style={{ marginTop: "1.5rem", gap: "1rem", display: 'flex' }}>
                <button
                  className="btn btn--outline-purple"
                  style={{ background: "transparent", padding: " 1.2rem" }}
                  onClick={handleCreativeUploadClick}
                >
                  Upload Creative
                </button>
                <button
                  className="btn btn--outline-purple"
                  style={{ background: "transparent", padding: " 1.2rem" }}
                  onClick={handleCopy}
                >
                  Copy Link
                </button>
              </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontSize: "1.8rem",
                fontWeight: 500,
              }}
            >
              Drop your creatives in the folder below.
              <span style={{ color: "red" }}>*</span>
            </div>

            <div
              style={{ fontSize: "1.4rem", fontWeight: 500, color: "#556179" }}
            >
              Upload the necessary files for processing:{" "}
              <span style={{ color: "#6B38C4" }}>
                Approval Emails* (.eml file only)
              </span>
            </div>
            <AdUploadFiles
              accept=".eml"
              fileList={fileList}
              setFileList={setFileList}
              currentStage={"Ad Release"}
              isUesrPermitted={isStepAccessible}
            />
          </div>
        </div>
        {!!isStepAccessible ? (
          <div className="layout-wrapper__footer">
            <button
              className="btn btn--purple"
              onClick={handleSubmitUploadFile}
              disabled={!fileList.length}
            >
              Submit for approval
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
